import { FeatureFlagsProvider } from '@/features/common/contexts/FeatureFlags';
import { GlobalDialogsProvider } from '@/features/common/contexts/GlobalDialogs';
import routes from '@/routes';
import { store } from '@/store';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { POSTHOG_OPTIONS } from './consts/app.const';
import { PostHogProvider } from 'posthog-js/react';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

export default function App() {
  return (
    <StrictMode>
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={POSTHOG_OPTIONS}
      >
        <Provider store={store}>
          <ToastContainer
            toastClassName="mx-4 mb-2 sm:mx-0 text-sm"
            position="bottom-right"
            draggable={false}
            closeButton={false}
            hideProgressBar
          />
          <FeatureFlagsProvider>
            <GlobalDialogsProvider>
              <RouterProvider router={router} />
            </GlobalDialogsProvider>
          </FeatureFlagsProvider>
        </Provider>
      </PostHogProvider>
    </StrictMode>
  );
}
